/**
 * PII PDF labels in Japanese — bundled so PDF is always correct even if
 * i18n HTTP backend / lng resolution fails for async PDF generation.
 */
export const PII_PDF_LABELS_JA = {
  piiPdf_reportTitle: "個人情報レポート",
  piiPdf_personalInformation: "個人情報",
  piiPdf_name: "氏名：",
  piiPdf_address: "住所：",
  piiPdf_occupation: "職業：",
  piiPdf_contactNo: "連絡先：",
  piiPdf_emailAddress: "メールアドレス：",
  piiPdf_tradeInInformation: "下取り情報",
  piiPdf_tradeInId: "下取りID：",
  piiPdf_tradeInDate: "下取り日：",
  piiPdf_deviceInformation: "端末情報",
  piiPdf_deviceName: "端末名：",
  piiPdf_imei: "IMEI：",
  piiPdf_manufacturer: "メーカー：",
  piiPdf_storage: "ストレージ：",
  piiPdf_emDash: "—",
};
